import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

import gsap from 'gsap';

export function initSplitSlider() {

  let time = 5000, speed = 1000;

  const splitSliderBody = new Swiper(".split-slider-body", {
    speed: speed,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    slidesPerView: 1,
    allowTouchMove: false,
  });

  const splitSliderBG = new Swiper('.split-slider-bg', {
    speed: speed,
    effect: 'fade',
    loop: true,
    allowTouchMove: false,

    fadeEffect: {
      crossFade: true
    },
  });


  const splitSliderTitle = new Swiper('.split-slider-title', {
    loop: true,
    slidesPerView: 'auto',
    speed: speed,
    // freeMode: {
    //   enabled: true,
    //   sticky: true,
    // },
    autoplay: {
      delay: time,
      disableOnInteraction: false
    },

    on: {
      click: function (swiper) {
        hideSlideContent();
        if (swiper.clickedIndex != swiper.activeIndex) {
          swiper.slideNext();
          splitSliderBG.slideNext();
          splitSliderBody.slideNext();
        } else {
          swiper.slidePrev();
          splitSliderBG.slidePrev();
          splitSliderBody.slidePrev();
        }
      },

      slideChange: function (swiper) {
        progressBar(swiper);
      },

      slideChangeTransitionStart: hideSlideContent,

      slideChangeTransitionEnd: function (swiper) {
        splitSliderBG.slideToLoop(swiper.realIndex);
        splitSliderBody.slideToLoop(swiper.realIndex);

        const activeSlide = splitSliderBody.slides[splitSliderBody.activeIndex];
        const text = activeSlide.querySelector('.split-slide__text .fade-content');
        const btn = activeSlide.querySelector('.split-slide__btn');

        gsap.to(text, {
          opacity: 1,
          rotateX: 0,
          y: 0,
          stagger: 0.1,
          ease: 'power3.inOut',
          duration: 1,
        })

        btn.classList.add('show')
      }
    }

  });

  function hideSlideContent() {
    gsap.to('.split-slider-body .split-slide:not(.swiper-slide-active) .split-slide__text .fade-content', {
      opacity: 0,
      rotateX: 30,
      y: 70,
      ease: 'power3.inOut',
      duration: 0.3,
    })
    gsap.to('.split-slider-body .split-slide:not(.swiper-slide-duplicate-active) .split-slide__text .fade-content', {
      opacity: 0,
      rotateX: 30,
      y: 70,
      ease: 'power3.inOut',
      duration: 0.3,
    })

    document.querySelectorAll('.split-slide__btn').forEach(btn => {
      btn.classList.remove('show')
    });
  }

  function progressBar(swiper) {
    let currentNum = document.querySelector('.current-slide-num .num-wrap');
    let nextNum = document.querySelector('.next-slide-num .num-wrap');
    let progressBar = document.querySelector('.progress-line .line');

    let slideIndex = swiper.realIndex;
    let lastSlide = swiper.loopedSlides - 1;
    let numHeight = document.querySelector('.slide-num li').getBoundingClientRect().height;

    gsap.to(currentNum, {
      y: (slideIndex) * -numHeight
    })
    gsap.to(nextNum, {
      y: (slideIndex === lastSlide) ? 0 : (slideIndex + 1) * -numHeight
    })
    gsap.fromTo(progressBar, {
      scaleX: 0
    }, {
      scaleX: 100 + '%',
      ease: 'none',
      duration: (time + speed) / 1000
    })
  }
}
